module.exports = __webpack_public_path__ + "img/ueberblick_en.fd646696.jpg";